import FieldType from '@app/store/FieldType';

export default function getCurrentScaleSize(type: FieldType, currentScale = 1) {
  let sizeSet = null;

  switch (type) {
    case FieldType.CHECKBOX_GROUP:
      sizeSet = [20, 20];
      break;
    // 문서편집기의 단일 체크박스
    case FieldType.CHECKBOX_FIELD:
      sizeSet = [20, 20];
      break;

    case FieldType.SIGNATURE_FIELD:
      sizeSet = [0, 0];
      break;
    case FieldType.TEXT_FIELD:
      sizeSet = [20.55, 174];
      break;
    default:
      throw new Error('Matched type is not existed');
  }

  return sizeSet.map((v) => v / currentScale);
}
